// Top-right pull-quote with mirroring chevrons and a small heart glyph.
// Sits absolutely inside the GoldFrame. Pure chrome.
export default function QuoteTag({ children }) {
  return (
    <p className="absolute right-6 top-6 z-10 max-w-[220px] text-right font-caps text-sm italic leading-snug text-gold-deep sm:right-10 sm:top-8">
      <span aria-hidden="true" className="mr-1">
        &ldquo;
      </span>
      {children}
      <span aria-hidden="true" className="ml-1">
        &rdquo;
      </span>
      <span aria-hidden="true" className="mt-2 block text-base">
        ♥
      </span>
    </p>
  );
}
